import React, { useState, Alert, P, BR, SPAN, FONT, B } from 'react';
import "./style.css";
import TermPrivacy from './termPrivacy';
import TermProfessional from './termProfessional';
import TermUser from './termUser';

export default function Terms({ history }) {
    
    return (
        <>
            <TermUser/>
            <TermProfessional/>
            <div className="dash" />
            <TermPrivacy/>
        </>
    )
}